<template>
    <div class="row">
        <div v-for="(val, index) in list" :key="index" :class="{'last-col-device': val.is_lastcol}" class="col col-xs-12 col-md-6">
            <div class="thumbnail alignment">
                <div class="wrap">
                    <div class="image">
                        <a :href="val.url"><img v-lazy="val.thumbnail" alt=""></a>
                        <div class="label-box" v-if="val.is_sponsor"><span class="label label-sponsored">Sponsored</span></div>
                    </div>
                    <div class="meta">
                        <div class="date" v-if="val.date">{{ val.date }}</div>
                        <h3 class="title line2"><a :href="val.url">{{ val.title }}</a></h3>
                        <div class="category" v-html="val.dptag"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

export default {
  name: 'ItemNewsList',
  data () {
    return {
      list: window._happening_list
    }
  },
  computed: {
    numList () {
      return this.list.length - 1
    }
  }
}
</script>
